if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'pdp_selected_options';
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector('.product-images') ? this.productWrapper.querySelector('.product-images') : this.productWrapper.querySelector('.product-quick-images');
        this.thumbnails = this.productSlider.matches('product-slider-thumbnails') ? this.productWrapper.querySelector('.product-thumbnail-container') : null;
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
    }

    connectedCallback() {
      this.autoSelectSingleVariant();
      this.applyStoredOptionsSelection();
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.persistSelectedOptions();
      if (!this.currentVariant) {
        if (this.hasAllOptionsSelected()) {
          this.toggleAddButton(true, false, true);
          this.setUnavailable();
        } else {
          this.setSelectOptions();
        }
      } else {
        this.updateVariantInput();
        this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut, true);
      }
      this.updateNotifyModalState();
    }

    onVariantChange() {
      this.updateOptions();
      this.persistSelectedOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      if (this.currentVariant) {
        this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut, true);
      }

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        if (this.hasAllOptionsSelected()) {
          this.setUnavailable();
        } else {
          this.setSelectOptions();
        }
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      this.updateNotifyModalState();
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          const checkedInput = fieldset.querySelector('input:checked');
          this.options.push(checkedInput ? checkedInput.value : '');
          const firstInput = fieldset.querySelector('input');
          this.option_keys.push(firstInput ? firstInput.name : '');
        }
      });
      this.dataset.options = this.options;
    }
    hasVariantParamInUrl() {
      try {
        const params = new URLSearchParams(window.location.search || '');
        return params.has('variant');
      } catch (e) {
        return false;
      }
    }
    readStoredOptions() {
      try {
        const raw = window.localStorage.getItem(this.storageKey);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return null;
        const record = {};
        parsed.forEach((entry) => {
          if (!entry || typeof entry !== 'object') return;
          const optionName = String(entry.optionName || '').trim().toLowerCase();
          const value = String(entry.value || '').trim();
          if (!optionName || !value) return;
          record[optionName] = value;
        });
        return Object.keys(record).length ? record : null;
      } catch (e) {
        return null;
      }
    }
    applyStoredOptionsSelection() {
      // URL variant is an explicit selection and should always win.
      if (this.hasVariantParamInUrl()) return;
      const saved = this.readStoredOptions();
      if (!saved) return;

      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));

      this.fieldsets.forEach((fieldset) => {
        // A size chosen in the theme editor is the PDP default and takes
        // precedence over a size saved from a previous product visit.
        if (fieldset.dataset.themePreselected === 'true') return;

        const handle = String(fieldset.dataset.handle || '').trim().toLowerCase();
        if (!handle || !saved[handle]) return;
        const desiredValue = String(saved[handle]).trim();
        if (!desiredValue) return;

        const select = fieldset.querySelector('select');
        if (select) {
          const options = Array.from(select.options || []);
          const targetOption = options.find((option) => {
            if (option.value !== desiredValue) return false;
            if (option.disabled) return false;
            if (option.hidden) return false;
            if (option.hasAttribute('hidden')) return false;
            return true;
          });
          if (targetOption) {
            select.value = desiredValue;
          }
          return;
        }

        const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
        if (!radios.length) return;
        const targetRadio = radios.find((input) => {
          if (input.value !== desiredValue) return false;
          if (input.disabled) return false;
          if (input.classList.contains('is-disabled')) return false;
          if (input.dataset.hideLength === 'true') return false;
          return true;
        });
        if (targetRadio) {
          targetRadio.checked = true;
        }
      });
    }
    persistSelectedOptions() {
      if (!this.fieldsets || !this.fieldsets.length) return;
      const legacySelected = [];

      this.fieldsets.forEach((fieldset) => {
        const handle = String(fieldset.dataset.handle || '').trim().toLowerCase();
        if (!handle) return;

        const select = fieldset.querySelector('select');
        let value = '';
        if (select) {
          value = String(select.value || '').trim();
        } else {
          const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
          value = String(checkedInput ? checkedInput.value : '').trim();
        }

        if (!value) return;
        legacySelected.push({
          optionName: handle,
          value: value
        });
      });

      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify(legacySelected));
      } catch (e) {
        // Ignore storage failures (private mode / quota errors).
      }
    }
    autoSelectSingleVariant() {
      const variantData = this.getVariantData();
      if (!variantData || variantData.length !== 1) return;
      const onlyVariant = variantData[0];
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      if (fieldsets.length !== 1) return;

      const fieldset = fieldsets[0];
      const optionValue = onlyVariant.options && onlyVariant.options[0];
      if (!optionValue) return;

      const select = fieldset.querySelector('select');
      if (select) {
        if (!select.value) {
          select.value = optionValue;
        }
        return;
      }

      const checked = fieldset.querySelector('input:checked');
      if (checked) return;

      const inputs = Array.from(fieldset.querySelectorAll('input'));
      const target = inputs.find((input) => input.value === optionValue);
      if (target) {
        target.checked = true;
      }
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(mediaId);

      if (this.thumbnails) {
        this.setActiveMediaSlider(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
      } else {
        this.setActiveMedia(activeMedia);
      }

    }
    setActiveMedia(activeMedia) {

      const responsiveLayout = this.productWrapper.hasAttribute('data-product-media-layout');
      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        if (!responsiveLayout || (this.hideVariants && element.classList.contains('product-images__slide-item--variant'))) {
          element.classList.remove('is-active');
        }
        if (responsiveLayout) element.classList.toggle('is-initial-selected', element === activeMedia);
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      if (!this.sticky) {
        window.setTimeout(() => {
          if (window.innerWidth > 1068) {
            let header_h = activeMedia.parentElement.offsetTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')),
              scroll_obj = {
                left: 0,
                behavior: 'instant'
              };

            if (header_h > 0) {
              scroll_obj.top = header_h;
            }
            window.scrollTo(scroll_obj);
          }
          activeMedia.parentElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }
    }
    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      const nextUrl = new URL(this.dataset.url, window.location.origin);
      const currentUrl = new URL(window.location.href);

      currentUrl.searchParams.forEach((value, key) => {
        if (key === 'variant') return;
        nextUrl.searchParams.set(key, value);
      });

      nextUrl.searchParams.set('variant', this.currentVariant.id);
      window.history.replaceState({}, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      const nextUrl = new URL(this.dataset.url, window.shopUrl);
      const currentUrl = new URL(window.location.href);

      currentUrl.searchParams.forEach((value, key) => {
        if (key === 'variant') return;
        nextUrl.searchParams.set(key, value);
      });

      nextUrl.searchParams.set('variant', this.currentVariant.id);
      shareButton.updateUrl(nextUrl.toString());
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          const notifyMeEnabled = Boolean(window.theme?.settings?.notify_me_enable);
          const notifyMeText = window.theme?.variantStrings?.notifyMe || 'Notify me';
          const isSoldOutState = String(text || '') === String(window.theme?.variantStrings?.soldOut || '');

          if (notifyMeEnabled && isSoldOutState) {
            submitButton.removeAttribute('disabled');
            submitButton.dataset.notifyMode = 'true';
            submitButton.classList.add('sold-out');
            submitButtonText.textContent = notifyMeText;
          } else {
            submitButton.setAttribute('disabled', 'disabled');
            submitButton.dataset.notifyMode = 'false';
            if (text) submitButtonText.textContent = text;
          }
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.dataset.notifyMode = 'false';
          submitButton.classList.remove('loading');
          submitButton.classList.remove('sold-out');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!disable) {
        if (price) price.classList.remove('visibility-hidden');
        if (price_fixed) price_fixed.classList.remove('visibility-hidden');
      }

      if (!modifyClass) return;
    }

    hasAllOptionsSelected() {
      if (!Array.isArray(this.options) || !this.options.length) return false;
      return this.options.every((value) => {
        if (value === undefined || value === null) return false;
        return String(value).trim() !== '';
      });
    }

    setSelectOptions() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);
      const selectOptionsText = window.theme?.variantStrings?.selectOptions || 'Select options';

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButtonText) return;
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.dataset.notifyMode = 'false';
        submitButton.classList.remove('sold-out');
        submitButtonText.textContent = selectOptionsText;
      });

      if (price) price.classList.remove('visibility-hidden');
      if (price_fixed) price_fixed.classList.remove('visibility-hidden');
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButton.dataset.notifyMode = 'false';
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }
    resolveInlineNotifyMessage(node, variant) {
      if (!node) return '';
      const readMessage = (key, attr) => String(node.dataset[key] || node.getAttribute(attr) || '').trim();
      const scenario1 = readMessage('notifyMessageScenario1', 'data-notify-message-scenario-1');
      const scenario2 = readMessage('notifyMessageScenario2', 'data-notify-message-scenario-2');
      const scenario3 = readMessage('notifyMessageScenario3', 'data-notify-message-scenario-3');
      const seasonal = String(node.dataset.notifySeasonal || node.getAttribute('data-notify-seasonal') || '') === 'true';
      const options = Array.isArray(variant?.options) ? variant.options : [];
      const normalized = options.map((option) => String(option || '').trim().toLowerCase());
      const compact = normalized.map((option) => option.replace(/[\s-]/g, ''));
      const hasAny = (values) => values.some((value) => compact.includes(value));
      const isScenario3SoldOut = variant && variant.available === false && (
        (hasAny(['small']) && hasAny(['tall'])) ||
        (hasAny(['3xlarge', '3xl', '3x']) && hasAny(['short'])) ||
        (hasAny(['4xlarge', '4xl', '4x']) && hasAny(['short']))
      );

      if (isScenario3SoldOut && scenario3) {
        return scenario3;
      }
      return seasonal ? (scenario2 || scenario1) : scenario1;
    }
    updateNotifyInlineMessages() {
      const selector = `[data-notify-inline-message][data-section="${this.dataset.section}"]`;
      document.querySelectorAll(selector).forEach((node) => {
        const message = this.resolveInlineNotifyMessage(node, this.currentVariant);
        const toggleButton = node.previousElementSibling;
        const isNotifyMode = toggleButton?.dataset?.notifyMode === 'true';
        node.textContent = message;
        node.hidden = !isNotifyMode || !message;
      });
    }
    updateNotifyModalState() {
      const modalId = `NotifyMeModal-${this.dataset.section}`;
      const modalList = Array.from(document.querySelectorAll(`#${modalId}`));
      let modal = null;
      if (modalList.length > 1) {
        modal = modalList[modalList.length - 1];
        modalList.slice(0, -1).forEach((staleModal) => {
          if (staleModal && staleModal.parentNode) {
            staleModal.parentNode.removeChild(staleModal);
          }
        });
      } else {
        modal = modalList[0] || null;
      }
      const variantId = this.currentVariant && this.currentVariant.id ? String(this.currentVariant.id) : '';

      if (modal) {
        const variantInput = modal.querySelector('[data-notify-variant-id]');
        const variantText = modal.querySelector('[data-notify-variant-text]');

        if (variantInput && variantText) {
          if (variantId) {
            variantInput.value = variantId;
            variantText.textContent = String(this.currentVariant.title || '').replace(/\s*\/\s*Default Title\s*$/i, '');
          } else {
            variantInput.value = '';
            variantText.textContent = '';
          }
        }
      }

      this.updateNotifyInlineMessages();
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {
        const selected_options = {
          option1: this.options[0] || null,
          option2: this.options[1] || null,
          option3: this.options[2] || null
        };

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        if (this.thumbnails) {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });

          // Product thumbnails
          this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_thumbs.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        } else {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            if (thumb.dataset.group === group) {
              thumb.classList.add('is-active');
            }
          });
        }

      } else {

        if (!this.thumbnails) {
          let set_images = Array.from(selected_set_images).filter(function (element) {
            return element.dataset.group === group;
          });
          set_images.forEach(thumb => {
            thumb.parentElement.prepend(thumb);
          });
        }

      }
      if (!this.thumbnails) {
        setTimeout(() => {
          this.productSlider.onPaginationResize?.();
        }, 100);
      }
    }

    createAvailableOptionsTree(variants, selectedValues) {
      const optionIndexKeys = ['option1', 'option2', 'option3'];
      const options = {
        option1: new Map(),
        option2: new Map(),
        option3: new Map()
      };

      variants.forEach((variant) => {
        optionIndexKeys.forEach((index) => {
          const value = variant[index];
          if (value === null) return;
          if (!options[index].has(value)) {
            options[index].set(value, { value, isUnavailable: true });
          }
        });
      });

      variants.forEach((variant) => {
        if (!variant.available) return;

        optionIndexKeys.forEach((index) => {
          const value = variant[index];
          if (value === null) return;

          const matches = optionIndexKeys.every((otherIndex) => {
            if (otherIndex === index) return true;
            const selected = selectedValues && selectedValues[otherIndex];
            if (!selected) return true;
            return variant[otherIndex] === selected;
          });

          if (matches) {
            options[index].get(value).isUnavailable = false;
          }
        });
      });

      return {
        option1: Array.from(options.option1.values()),
        option2: Array.from(options.option2.values()),
        option3: Array.from(options.option3.values())
      };
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.mobileTwoImage = this.dataset.mobileTwoImage === 'true';
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
      this.progressBar = this.parentElement.querySelector('.product-images-progress .flickity-progress--bar');

      // Start Gallery
      this.galleryObserver = new MutationObserver(() => {
        this.setupProductGallery();
      });

      this.galleryObserver.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }
    disconnectedCallback() {
      this.galleryObserver?.disconnect();
      this.resizeObserver?.disconnect();
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true,
          timeToIdle: 0,
          timeToIdleOutside: 0,
          tapToToggleControls: false
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          if (pswpElement && pswpElement.parentElement !== document.body) {
            document.body.appendChild(pswpElement);
          }
          if (pswpElement) {
            const viewportWidth = window.visualViewport?.width || window.innerWidth;
            const viewportHeight = window.visualViewport?.height || window.innerHeight;
            pswpElement.style.width = `${viewportWidth}px`;
            pswpElement.style.height = `${viewportHeight}px`;
            pswpElement.style.left = '0';
            pswpElement.style.top = '0';
            pswpElement.style.right = '0';
            pswpElement.style.bottom = '0';
            pswpElement.style.transform = 'none';
            const applyUiOffsets = () => {
              const closeButton = pswpElement.querySelector('.pswp__button--close');
              const rightArrow = pswpElement.querySelector('.pswp__button--arrow--right');
              const viewportWidth = window.visualViewport?.width || window.innerWidth || document.documentElement.clientWidth || 0;

              const setLeftOffset = (el) => {
                if (!el || !viewportWidth) return;
                const width = el.offsetWidth || 0;
                const left = Math.max(0, viewportWidth - width - 15);
                el.style.left = `${left}px`;
                el.style.right = 'auto';
              };

              setLeftOffset(closeButton);
              setLeftOffset(rightArrow);
            };
            requestAnimationFrame(applyUiOffsets);
            window.addEventListener('resize', () => requestAnimationFrame(applyUiOffsets), { passive: true, once: true });
          }
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
          pswp.invalidateCurrItems();
          pswp.updateSize(true);
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

      if (this.mobileTwoImage && window.innerWidth <= 1067) {
        this.querySelectorAll('.product-single__media-image').forEach((media) => {
          if (media.dataset.zoomClickBound === 'true') return;
          const zoomLink = media.querySelector('.product-single__media-zoom');
          if (!zoomLink) return;
          media.dataset.zoomClickBound = 'true';
          media.addEventListener('click', (e) => {
            if (e.target.closest('a')) return;
            e.preventDefault();
            zoomLink.click();
          });
        });
      }

      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          const externalVideo = container.closest('.product-single__media-external-video');
          if (!externalVideo) return;

          if (externalVideo.dataset.videoLoaded !== 'true') {
            const template = externalVideo.querySelector('.product-single__media-external-video-template');
            if (template) {
              externalVideo.appendChild(template.content.cloneNode(true));
              externalVideo.dataset.videoLoaded = 'true';
            }
          }

          container.setAttribute('hidden', '');
        });
      });
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.itemsPerPage = this.getItemsPerPage();

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      const step = this.sliderItemOffset * this.itemsPerPage;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + step : this.scrollLeft - step;
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.itemsPerPage = this.getItemsPerPage();
      const pageOffset = this.sliderItemOffset * this.itemsPerPage;
      this.currentPage = Math.round(this.scrollLeft / pageOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = Math.ceil(this.sliderItemsToShow.length / this.itemsPerPage);
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }

      if (this.progressBar) {
        const maxScroll = this.scrollWidth - this.clientWidth;
        const progress = maxScroll > 0 ? Math.min(1, Math.max(0, this.scrollLeft / maxScroll)) : 0;
        this.progressBar.style.width = `${progress * 100}%`;
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
    getItemsPerPage() {
      if (!this.mobileTwoImage) return 1;
      return window.innerWidth <= 1067 ? 2 : 1;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      const sections = parsedState && parsedState.sections ? parsedState.sections : null;
      if (!sections) {
        this.fetchAndRenderSections();
        return;
      }
      this.renderSections(sections, parsedState);
    }
    renderSections(sections, parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        if (!sections[section.section]) {
          return;
        }
        elementToReplace.innerHTML = this.getSectionInnerHTML(sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
  }
}
    fetchAndRenderSections() {
      const sectionIds = this.getSectionsToRender().map((section) => section.section).join(',');
      fetch(`${window.location.pathname}?sections=${sectionIds}`)
        .then((response) => response.json())
        .then((sections) => {
          if (!sections) return;
          this.renderSections(sections, { sections });
        })
        .catch((error) => {
          console.error(error);
        });
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function initSellingPlanToggles(root = document) {
  if (!root) return;
  const toggles = Array.from(root.querySelectorAll('[data-selling-plan]'));
  if (!toggles.length) return;

  toggles.forEach((toggle) => {
    if (toggle.dataset.initialized === 'true') return;
    toggle.dataset.initialized = 'true';

    const optionButtons = toggle.querySelectorAll('[data-selling-plan-option]');
    const planButtons = toggle.querySelectorAll('[data-selling-plan-id]');
    const plansWrap = toggle.querySelector('.product-selling-plan__plans');
    const input = toggle.querySelector('[data-selling-plan-input]');
    const formId = input ? input.getAttribute('form') : null;

    function syncFormInputs(activeInput, isEnabled) {
      if (!formId) return;
      const inputs = document.querySelectorAll(`input[name="selling_plan"][form="${formId}"]`);
      inputs.forEach((node) => {
        if (node === activeInput) return;
        node.disabled = true;
        if (!isEnabled) node.value = '';
      });
    }

    function setActiveOption(value) {
      optionButtons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.sellingPlanOption === value);
        btn.setAttribute('aria-pressed', btn.dataset.sellingPlanOption === value ? 'true' : 'false');
      });
    }

    function setActivePlan(id) {
      planButtons.forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.sellingPlanId === id);
        btn.setAttribute('aria-pressed', btn.dataset.sellingPlanId === id ? 'true' : 'false');
      });
      if (input) {
        input.disabled = false;
        input.value = id;
        syncFormInputs(input, true);
      }
    }

    optionButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const mode = btn.dataset.sellingPlanOption;
        setActiveOption(mode);

        if (mode === 'onetime') {
          if (plansWrap) plansWrap.classList.add('is-hidden');
          if (input) {
            input.disabled = true;
            input.value = '';
            syncFormInputs(input, false);
          }
          return;
        }

        if (plansWrap) plansWrap.classList.remove('is-hidden');
        const activePlan = toggle.querySelector('[data-selling-plan-id].is-active') || planButtons[0];
        if (activePlan) setActivePlan(activePlan.dataset.sellingPlanId);
      });
    });

    planButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        setActivePlan(btn.dataset.sellingPlanId);
      });
    });

    if (optionButtons.length === 1 && optionButtons[0].dataset.sellingPlanOption === 'subscription') {
      setActiveOption('subscription');
      if (plansWrap) plansWrap.classList.remove('is-hidden');
      const initialPlan = toggle.dataset.defaultPlan || (planButtons[0] && planButtons[0].dataset.sellingPlanId);
      if (initialPlan) setActivePlan(initialPlan);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initSellingPlanToggles();
});

document.addEventListener('shopify:section:load', (event) => {
  initSellingPlanToggles(event.target);
});

document.addEventListener('quick-view:open', () => {
  const quickViewRoot = document.getElementById('Product-Drawer-Content');
  initSellingPlanToggles(quickViewRoot || document);
});

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }


    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

if (!window.FCT) {
  window.FCT = {};
}

if (!window.FCT.reviewScrollHandlerBound && document.body.classList.contains('template-product')) {
  // Delegate clicks so re-rendered rating links still work after section swaps.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.star-rating-container');
    if (!trigger) return;

    event.preventDefault();

    const target = document.querySelector('.okeReviews-widget-holder');
    if (!target) return;

    const rootStyles = getComputedStyle(document.documentElement);
    const headerHeight = parseInt(rootStyles.getPropertyValue('--header-height'), 10) || 0;
    const targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({
      top: targetTop,
      behavior: 'smooth'
    });
  });

  window.FCT.reviewScrollHandlerBound = true;
}

if (!window.FCT.notifyMeBound) {
  const getLatestNotifyModal = (sectionId) => {
    if (!sectionId) return null;
    const selector = `#NotifyMeModal-${sectionId}`;
    const modals = Array.from(document.querySelectorAll(selector));
    if (!modals.length) return null;
    if (modals.length > 1) {
      const latest = modals[modals.length - 1];
      modals.slice(0, -1).forEach((modal) => {
        // Old modals can stay in <body> after PDP main content swap; remove stale duplicates.
        if (modal && modal.parentNode) {
          modal.parentNode.removeChild(modal);
        }
      });
      return latest;
    }
    return modals[0];
  };

  const setNotifyError = (modal, message) => {
    const errorNode = modal.querySelector('[data-notify-error]');
    if (!errorNode) return;
    errorNode.textContent = message;
    errorNode.hidden = false;
  };

  const clearNotifyError = (modal) => {
    const errorNode = modal.querySelector('[data-notify-error]');
    if (!errorNode) return;
    errorNode.hidden = true;
  };

  const isScenario3SoldOutVariant = (variant) => {
    if (!variant || variant.available !== false) return false;
    const options = Array.isArray(variant.options) ? variant.options : [];
    const normalized = options.map((option) => String(option || '').trim().toLowerCase());
    const compact = normalized.map((option) => option.replace(/[\s-]/g, ''));
    const hasAny = (values) => values.some((value) => compact.includes(value));

    return (
      (hasAny(['small']) && hasAny(['tall'])) ||
      (hasAny(['3xlarge', '3xl', '3x']) && hasAny(['short'])) ||
      (hasAny(['4xlarge', '4xl', '4x']) && hasAny(['short']))
    );
  };

  const resolveNotifyMessage = (node, variant) => {
    if (!node) return '';
    const readMessage = (key, attr) => String(node.dataset[key] || node.getAttribute(attr) || '').trim();
    const scenario1 = readMessage('notifyMessageScenario1', 'data-notify-message-scenario-1');
    const scenario2 = readMessage('notifyMessageScenario2', 'data-notify-message-scenario-2');
    const scenario3 = readMessage('notifyMessageScenario3', 'data-notify-message-scenario-3');
    const seasonal = String(node.dataset.notifySeasonal || node.getAttribute('data-notify-seasonal') || '') === 'true';

    if (isScenario3SoldOutVariant(variant) && scenario3) {
      return scenario3;
    }
    return seasonal ? (scenario2 || scenario1) : scenario1;
  };

  const formatNotifyMoney = (cents) => {
    const value = Number(cents || 0);
    const stripMarkup = (raw) => {
      const holder = document.createElement('div');
      holder.innerHTML = String(raw || '');
      return (holder.textContent || '').trim();
    };
    if (typeof formatMoney === 'function') {
      return stripMarkup(formatMoney(value, window.theme?.settings?.money_with_currency_format || '${{amount}}'));
    }
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return stripMarkup(Shopify.formatMoney(value, window.theme?.settings?.money_with_currency_format || '${{amount}}'));
    }
    return `$${(value / 100).toFixed(2)}`;
  };

  const getVariantById = (sectionId, variantId) => {
    if (!sectionId || !variantId) return null;
    const selector = `variant-selects[data-section="${sectionId}"]`;
    const variantSelect = document.querySelector(selector);
    if (!variantSelect || typeof variantSelect.getVariantData !== 'function') return null;
    const variant = variantSelect.getVariantData().find((item) => String(item.id) === String(variantId));
    return variant || null;
  };

  const updateNotifyModalVariant = (modal, sectionId, variantId) => {
    const variantIdInput = modal.querySelector('[data-notify-variant-id]');
    const variantTextNode = modal.querySelector('[data-notify-variant-text]');
    const priceNode = modal.querySelector('[data-notify-price]');
    const compareNode = modal.querySelector('[data-notify-compare]');
    const popupMessageNode = modal.querySelector('[data-notify-popup-message]');

    if (variantIdInput) {
      variantIdInput.value = variantId || '';
    }

    const variant = getVariantById(sectionId, variantId);
    if (popupMessageNode) {
      popupMessageNode.textContent = resolveNotifyMessage(popupMessageNode, variant);
    }
    if (!variant) {
      if (variantTextNode) variantTextNode.textContent = '';
      if (compareNode) compareNode.hidden = true;
      return;
    }

    if (variantTextNode) {
      variantTextNode.textContent = String(variant.title || '').replace(/\s*\/\s*Default Title\s*$/i, '');
    }

    if (priceNode) {
      priceNode.textContent = formatNotifyMoney(variant.price);
    }

    const compareAt = Number(variant.compare_at_price || 0);
    if (compareNode) {
      if (compareAt > Number(variant.price || 0)) {
        compareNode.hidden = false;
        compareNode.textContent = formatNotifyMoney(compareAt);
      } else {
        compareNode.hidden = true;
      }
    }
  };

  const syncNotifyModalProductMeta = (button, modal) => {
    if (!button || !modal) return;
    const root = button.closest('.thb-product-detail, .product') || document;

    const titleNode = root.querySelector('.product-title, .product-title-word-break, .product-add-to-cart-sticky--title, h1');
    const modalTitleNode = modal.querySelector('.notify-me-modal__title');
    if (titleNode && modalTitleNode) {
      const text = String(titleNode.textContent || '').trim();
      if (text) modalTitleNode.textContent = text;
    }

    const activeImg =
      root.querySelector('.product-images .is-selected img') ||
      root.querySelector('.product-images .is-active img') ||
      root.querySelector('.product-images img') ||
      root.querySelector('.product-add-to-cart-sticky--image img');

    const modalImg = modal.querySelector('.notify-me-modal__image');
    if (activeImg && modalImg) {
      const src = activeImg.getAttribute('src') || activeImg.getAttribute('data-src') || '';
      const alt = activeImg.getAttribute('alt') || '';
      if (src) modalImg.setAttribute('src', src);
      modalImg.setAttribute('alt', alt);
    }
  };

  const updateNotifyInlineMessagesBySection = (sectionId, variantId) => {
    if (!sectionId) return;
    const variant = getVariantById(sectionId, variantId);
    const selector = `[data-notify-inline-message][data-section="${sectionId}"]`;
    const messageNodes = document.querySelectorAll(selector);

    messageNodes.forEach((node) => {
      const message = resolveNotifyMessage(node, variant);
      const toggleButton = node.previousElementSibling;
      const isNotifyMode = toggleButton?.dataset?.notifyMode === 'true';
      node.textContent = message;
      node.hidden = !isNotifyMode || !message;
    });
  };

  const openNotifyModal = (button) => {
    const productForm = button.closest('product-form');
    const sectionId = productForm?.dataset?.section;
    if (!sectionId) return;

    const modal = getLatestNotifyModal(sectionId);
    if (!modal || typeof modal.show !== 'function') return;

    const form = button.closest('form');
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    const variantId = idInput ? String(idInput.value || '').trim() : '';
    const variantIdInput = modal.querySelector('[data-notify-variant-id]');
    const notifyForm = modal.querySelector('[data-notify-form]');
    const submitButton = modal.querySelector('[data-notify-submit]');

    syncNotifyModalProductMeta(button, modal);
    updateNotifyModalVariant(modal, sectionId, variantId);
    updateNotifyInlineMessagesBySection(sectionId, variantId);
    if (notifyForm) {
      notifyForm.reset();
      if (variantIdInput) {
        variantIdInput.value = variantId;
      }
    }
    if (submitButton) {
      submitButton.classList.remove('is-loading');
      submitButton.classList.remove('is-success');
      submitButton.disabled = false;
    }

    clearNotifyError(modal);
    modal.show(button);
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const button = target.closest('.single-add-to-cart-button[data-notify-mode="true"]');
    if (!button) return;
    event.preventDefault();
    openNotifyModal(button);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-notify-form]');
    if (!form) return;
    event.preventDefault();

    const modal = form.closest('[data-notify-modal]');
    if (!modal) return;

    const submitButton = form.querySelector('[data-notify-submit]');
    const formData = new FormData(form);
    const email = String(formData.get('email') || '').trim();
    const variantId = String(formData.get('variantId') || '').trim();
    const apiKey = String(modal.dataset.apiKey || window.theme?.settings?.klaviyo_public_api_key || '').trim();
    const listId = String(modal.dataset.listId || window.theme?.settings?.klaviyo_public_list_id || '').trim();

    clearNotifyError(modal);

    if (!variantId) {
      setNotifyError(modal, 'Select all product options first.');
      return;
    }
    if (!email) {
      setNotifyError(modal, 'Enter a valid email address.');
      return;
    }
    if (!apiKey) {
      setNotifyError(modal, 'Klaviyo API key is not configured.');
      return;
    }

    if (submitButton) {
      submitButton.classList.add('is-loading');
      submitButton.disabled = true;
    }

    try {
      const backInStockResponse = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(apiKey)}`, {
        method: 'POST',
        headers: {
          revision: '2024-02-15',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email }
                }
              },
              channels: ['EMAIL']
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        })
      });

      let listResponseOk = true;
      if (listId) {
        const listResponse = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(apiKey)}`, {
          method: 'POST',
          headers: {
            revision: '2024-02-15',
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Notify Me form',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId
                  }
                }
              }
            }
          })
        });
        listResponseOk = listResponse.status === 202;
      }

      if (backInStockResponse.status === 202 && listResponseOk) {
        if (submitButton) {
          submitButton.classList.remove('is-loading');
          submitButton.classList.add('is-success');
        }
        return;
      }

      if (submitButton) {
        submitButton.classList.remove('is-loading');
        submitButton.disabled = false;
      }
      setNotifyError(modal, 'Something went wrong. Try again later.');
    } catch (error) {
      if (submitButton) {
        submitButton.classList.remove('is-loading');
        submitButton.disabled = false;
      }
      setNotifyError(modal, 'Something went wrong. Try again later.');
    }
  });

  window.FCT.notifyMeBound = true;
}
